import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import _createForOfIteratorHelper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import queryString from '../utils/queryString';
var isDev = process.env.NODE_ENV !== 'production';
var DefaultScene = ['DefaultScene'];
var currentScene = getSceneFromUrl() || {
  DefaultScene: undefined
};
var urlMockConfs = [];

function log(msg) {
  msg = '[mock] ' + msg;

  for (var _len = arguments.length, arr = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arr[_key - 1] = arguments[_key];
  }

  arr.unshift(msg);
  console.log.apply(console, arr);
}
/**
 * 设置mock场景，匹配场景的mock值将被设置
 * @param {string} scene
 */


export function setScene(scene) {
  if (isDev) {
    if (!Array.isArray(scene)) {
      scene = [scene];
    }

    if (!scene) throw new Error('设置mock场景，请传入场景值');
    currentScene = {};
    scene.forEach(function (item) {
      var _cutSceneParam = cutSceneParam(item),
          _cutSceneParam2 = _slicedToArray(_cutSceneParam, 2),
          sceneItem = _cutSceneParam2[0],
          paramItem = _cutSceneParam2[1];

      currentScene[sceneItem] = paramItem;
    });
    log("\u5DF2\u8BBE\u7F6E\u573A\u666F\u503C\u4E3A ".concat(scene));
  }
}

function getSceneFromUrl() {
  if (isDev) {
    var search = new URLSearchParams(window.location.search);
    var scene = search.get('mockScene') || search.get('scene');

    if (scene) {
      log("\u53D1\u73B0url\u4E2Dscene\u53C2\u6570\uFF0C\u5DF2\u8BBE\u7F6E\u573A\u666F\u503C\u4E3A ".concat(scene));
      scene = scene.split(',');
      var _currentScene = {};
      scene.forEach(function (item) {
        var _cutSceneParam3 = cutSceneParam(item),
            _cutSceneParam4 = _slicedToArray(_cutSceneParam3, 2),
            sceneItem = _cutSceneParam4[0],
            paramItem = _cutSceneParam4[1];

        _currentScene[sceneItem] = paramItem;
      });
      return _currentScene;
    }

    return {};
  }
}

function cutSceneParam(sceneInfo) {
  // 第一个出现的 ':' 场景:参数 分隔符
  var delimiterPos = sceneInfo.indexOf(':');
  var param;
  var scene = sceneInfo;

  if (delimiterPos >= 0) {
    scene = sceneInfo.slice(0, delimiterPos);
    param = sceneInfo.slice(delimiterPos + 1);
  }

  return [scene, param];
}
/**
 * 在sender中用于检查是否有mock数据，如果有mock数据，sender直接返回即可，不需要发起网络请求
 * @param {Context} context
 */


export function checkMock(context) {
  if (isDev) {
    if (context.mockData) {
      context.response = context.mockData;
      return true;
    } else {
      var _iterator = _createForOfIteratorHelper(urlMockConfs),
          _step;

      try {
        var _loop = function _loop() {
          var _step$value = _step.value,
              urlPattern = _step$value.urlPattern,
              mockData = _step$value.mockData,
              scene = _step$value.scene;
          var reqUrl = context.request.reqUrl;
          var keys = Object.keys(currentScene);
          var hitScene = scene.find(function (item) {
            return keys.indexOf(item) >= 0;
          });

          if (hitScene && reqUrl.search(urlPattern) >= 0) {
            log("\u8BF7\u6C42 ".concat(reqUrl, " \u7B26\u5408\u5F53\u524D\u7684\u573A\u666F ").concat(hitScene, ", \u7B26\u5408urlPattern ").concat(urlPattern, ", \u5DF2mock\u6570\u636E\u4E3A"), mockData);
            context.response = mockData;
            return {
              v: true
            };
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  return false;
}
/**
 * 根据url匹配来mock数据
 * @param {string|Regex} urlPattern
 * @param {Object} mockData
 * @param {string} scene
 */

export function mockByUrl(urlPattern, mockData) {
  var scene = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultScene;

  if (isDev) {
    if (!Array.isArray(scene)) {
      scene = [scene];
    }

    urlMockConfs.push({
      urlPattern: urlPattern,
      mockData: mockData,
      scene: scene
    });
  } else {
    return undefined;
  }
}
/**
 * mock中间件，可根据不同场景设置mock值
 * @param {Object} mockData mock返回值
 * @param {string|Array} scene 场景值，可为场景数组，不传则为默认场景值
 */

export function mock(mockData) {
  var scene = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultScene;

  if (isDev) {
    if (!Array.isArray(scene)) {
      scene = [scene];
    }

    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
        var param, hitScene, hit, keys, _iterator2, _step2, item, searchStr, url, ret;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hit = false;
                keys = Object.keys(currentScene);
                _iterator2 = _createForOfIteratorHelper(scene);
                _context.prev = 3;

                _iterator2.s();

              case 5:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 14;
                  break;
                }

                item = _step2.value;

                if (!(keys.indexOf(item) >= 0)) {
                  _context.next = 12;
                  break;
                }

                hit = true;
                param = currentScene[item];
                hitScene = item;
                return _context.abrupt("break", 14);

              case 12:
                _context.next = 5;
                break;

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](3);

                _iterator2.e(_context.t0);

              case 19:
                _context.prev = 19;

                _iterator2.f();

                return _context.finish(19);

              case 22:
                if (hit) {
                  searchStr = queryString(this.request.data);
                  url = this.request.url + (this.request.url.indexOf('?') >= 0 ? '&' : '?') + searchStr;
                  ret = typeof mockData === 'function' ? mockData(param) : mockData;
                  log("\u8BF7\u6C42 ".concat(url, " \u7B26\u5408\u5F53\u524D\u7684\u573A\u666F ").concat(hitScene, ", \u5DF2mock\u6570\u636E\u4E3A"), ret);
                  this.mockData = ret;
                }

                return _context.abrupt("return", next());

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 16, 19, 22]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  } else {
    return undefined;
  }
}